import * as Sentry from '@sentry/browser';

import store from '../redux/store';
import { isProd, release } from '../config';
import { getAccessToken } from '../redux/selectors';

const asyncFetch = async (url, body) => {
    try {
        const token = getAccessToken(store.getState());
        const response = await fetch(url, {
            body,
            mode: 'cors',
            method: 'POST',
            cache: 'default',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + (token || ''),
            },
        });
        const result = await response.json();

        if (response.status !== 200) {
            if (isProd && release) {
                Sentry.withScope((scope) => {
                    // scope.setExtras(info);
                    scope.setTag('source', 'api');
                    scope.setTag('query', body);
                    Sentry.captureException(result.errors);
                });
            }
        }

        return result;
    } catch (error) {
        if (isProd && release) {
            Sentry.withScope((scope) => {
                // scope.setExtras(info);
                scope.setTag('source', 'api');
                scope.setTag('query', body);
                Sentry.captureException(error);
            });
        }
    }
};

export default asyncFetch;
